<form [formGroup]="formGroup" (validSubmit)="register()">
    <div class="form-group mb-3">
        <label class="form-label">{{"Firstname" | translate}}</label>
        <input 
            type="text" 
            class="form-control no-validation-icon no-success-validation" 
            formControlName="firstName"
        >
    </div>
    <div class="form-group mb-3">
        <label class="form-label">{{"Lastname"  | translate}}</label>
        <input 
            type="text" 
            class="form-control no-validation-icon no-success-validation" 
            formControlName="lastName"
        >
    </div>
    <div class="form-group mb-3">
        <label class="form-label">{{"Email" | translate}}</label>
        <input 
            type="email" 
            class="form-control no-validation-icon no-success-validation" 
            formControlName="email"
        >
    </div>
    <div class="form-group mb-3">
        <label class="form-label">{{"Username" |  translate}}</label>
        <input 
            type="email" 
            class="form-control no-validation-icon no-success-validation" 
            formControlName="userName"
        >
    </div>
    <div class="form-group mb-3">
        <label class="form-label">{{"Password" |  translate}}</label>
        <input 
            type="password" 
            class="form-control no-validation-icon no-success-validation" 
            formControlName="password"
        >
    </div>
    <div class="form-group mb-3">
        <label class="form-label">{{"Confirm Password" | translate}}</label>
        <input 
            type="password" 
            class="form-control no-validation-icon no-success-validation" 
            formControlName="confirmPassword"
        >
        <ng-container *ngIf="formGroup.get('confirmPassword').hasError('confirm')">
            <span class="invalid-feedback">{{"Password not match" | translate}}</span>
        </ng-container>
    </div>
    <button class="btn btn-primary d-block w-100" type="submit">{{"Sign Up"  | translate}}</button>
</form>
